// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2wcHu","col":"styles_col__VSYSF"};